import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const EMPTY = { current_password: "", new_password: "", confirm: "" };
const FIELDS = [["current_password", "Current password"], ["new_password", "New password (at least 10 characters)"], ["confirm", "Confirm new password"]];

export function ChangePasswordCard() {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 10) return toast.error("New password must be at least 10 characters");
    if (f.new_password !== f.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed");
      setF(EMPTY);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="mb-6 border border-stone bg-paper p-6" data-testid="change-password-card">
      <h2 className="mb-5 font-serif text-2xl">Change password</h2>
      <form onSubmit={submit} className="grid gap-5 sm:grid-cols-3">
        {FIELDS.map(([k, l]) => (
          <div key={k}>
            <label htmlFor={`pw-${k}`} className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.1em] text-charcoal/75">{l}</label>
            <input id={`pw-${k}`} type="password" autoComplete={k === "current_password" ? "current-password" : "new-password"} required className="field !py-2.5 text-sm" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`pw-${k}`} />
          </div>
        ))}
        <div className="sm:col-span-3">
          <button type="submit" disabled={busy} className="btn btn-primary !py-3" data-testid="pw-submit">{busy ? "Updating…" : "Update password"}</button>
        </div>
      </form>
    </section>
  );
}
